import { DataExplorerResource, DataTreeResourceRequestProps, DataExplorerView } from 'features/new-data-explorer/types'
import { createContext } from 'react'
import { useContext } from 'react'
import { CartoApiError } from 'features/common'

import { UseInfiniteQueryResult } from 'react-query'
import { Connection } from 'features/connections/types'

export type ToggleTreeItemProps = {
  itemId: string
  connection: Connection
  type: string
  isExpanded?: boolean
  fqn?: string
}
export type ViewResource = (resourceParams: DataTreeResourceRequestProps, nodeId?: string, refetch?: boolean) => void

export interface DataExplorerContextType {
  resourcesParams: DataTreeResourceRequestProps
  dataExplorerResources: UseInfiniteQueryResult<DataExplorerResource, CartoApiError>
  selectedConnection?: Connection
  expandedNodes: string[]
  expandNode: (nodeId: string) => void
  removeExpandedNodeCallback: (nodeId: string) => void
  viewResource: ViewResource
  loadAndViewResource: (resource: { connectionId: string; fqn?: string }, search?: boolean) => Promise<void>
  selectedIds: string[]
  setSelectedIds: (ids: string[]) => void
  view: DataExplorerView
  setView: (view: DataExplorerView) => void
  showBookmarks: boolean
  setShowBookmarks: (showBookmarks: boolean) => void
  toggleTreeItem: (props: ToggleTreeItemProps) => void
}

export const DataExplorerContext = createContext<DataExplorerContextType | undefined>(undefined)

export const useDataExplorerContext = () => {
  const context = useContext(DataExplorerContext)

  if (!context) {
    throw new Error('useDataExplorer must be used within a DataExplorerProvider')
  }
  return context
}
